import gql from 'graphql-tag';
export const StatFeatureKinderConnect = gql `
    fragment StatFeatureKinderConnect on KinderConnectFeatureSettingsFlags {
        enabled
    }
`;
